var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module",class:_vm.loading ? 'module--loading' : ''},[_c('div',{staticClass:"module__media bg-dark-pink"}),_vm._m(0),_c('div',{staticClass:"module__main"},[_c('fieldset',[_c('cludo-vue-input',{staticClass:"form-control form-control--search",attrs:{"placeholder":"Search..."}},[_c('span',{staticClass:"sr-only"},[_vm._v("Search")]),_c('i',{staticClass:"icon-search",attrs:{"aria-hidden":"true"}})])],1),_c('button',{staticClass:"button button--small button--block button--toggle toggle toggle--m",attrs:{"type":"button","aria-expanded":"false","aria-controls":"search-filters","data-toggle":"true"}},[_vm._v(" Filter "),(_vm.isFiltering)?_c('span',{staticClass:"badge bg-white"},[_vm._v(_vm._s(_vm.filtersCount))]):_vm._e()]),_c('SearchSorts',{attrs:{"label":"Sort by:","sorts":[
        {
          text: 'Default Name (A-Z)',
          name: 'Title',
          value: 'asc',
          selected: true,
        },
      ]}}),_c('div',{staticClass:"collapse collapse--tablet-expanded",attrs:{"id":"search-filters"}},[_c('div',{staticClass:"collapse__content"},[_c('cludo-vue-check-boxes',{attrs:{"type":"single","options":[
            {
              label: 'All',
              name: 'fee_status_all',
              field: 'fee_status',
              value: '', // keep default blank
              checked: true,
            },
            {
              label: 'Channel Islands and Isle of Man',
              name: 'fee_status_channel_islands_and_isle_of_man',
              field: 'fee_status',
              value: 'Channel Islands and Isle of Man',
            },
            {
              label: 'EU',
              name: 'fee_status_eu',
              field: 'fee_status',
              value: 'EU',
            },
            {
              label: 'International',
              name: 'fee_status_international',
              field: 'fee_status',
              value: 'International',
            },
            {
              label: 'UK',
              name: 'fee_status_uk',
              field: 'fee_status',
              value: 'UK',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Fee status")])])]),_c('cludo-vue-check-boxes',{attrs:{"type":"single","options":[
            {
              label: 'All',
              name: 'study_stage_all',
              field: 'study_stage',
              value: '', // keep default blank
              checked: true,
            },
            {
              label: 'Alumni',
              name: 'study_stage_alumni',
              field: 'study_stage',
              value: 'Alumni',
            },
            {
              label: 'Applicant',
              name: 'study_stage_applicant',
              field: 'study_stage',
              value: 'Applicant',
            },
            {
              label: 'Current',
              name: 'study_stage_current',
              field: 'study_stage',
              value: 'Current',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Study Stage")])])]),_c('cludo-vue-check-boxes',{attrs:{"type":"single","options":[
            {
              label: 'All',
              name: 'study_level_all',
              field: 'study_level',
              value: '', // keep default blank
              checked: true,
            },
            {
              label: 'Continuing Professional Development',
              name: 'study_level_continuing_professional_development',
              field: 'study_level',
              value: 'Continuing Professional Development',
            },
            {
              label: 'Foundation',
              name: 'study_level_foundation',
              field: 'study_level',
              value: 'Foundation',
            },
            {
              label: 'Postgraduate research',
              name: 'study_level_postgraduate_research',
              field: 'study_level',
              value: 'Postgraduate research',
            },
            {
              label: 'Postgraduate taught',
              name: 'study_level_postgraduate_taught',
              field: 'study_level',
              value: 'Postgraduate taught',
            },
            {
              label: 'Undergraduate',
              name: 'study_level_undergraduate',
              field: 'study_level',
              value: 'Undergraduate',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Study Level")])])]),_c('cludo-vue-check-boxes',{attrs:{"type":"single","options":[
            {
              label: 'All',
              name: 'study_mode_all',
              field: 'study_mode',
              value: '', // keep default blank
              checked: true,
            },
            {
              label: 'Full-time',
              name: 'study_mode_full_time',
              field: 'study_mode',
              value: 'Full-time',
            },
            {
              label: 'Part-time',
              name: 'study_mode_part_time',
              field: 'study_mode',
              value: 'Part-time',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Study Stage")])])]),_c('cludo-vue-check-boxes',{attrs:{"type":"single","options":[
            {
              label: 'All',
              name: 'funding_category_all',
              field: 'funding_category',
              value: '', // keep default blank
              checked: true,
            },
            {
              label: 'Accommodation',
              name: 'funding_category_accommodation',
              field: 'funding_category',
              value: 'Accommodation',
            },
            {
              label: 'Community & engagement',
              name: 'funding_category_community_and_engagement',
              field: 'funding_category',
              value: 'Community & engagement',
            },
            {
              label: 'Financial support',
              name: 'funding_category_financial_support',
              field: 'funding_category',
              value: 'Financial support',
            },
            {
              label: 'Graduation',
              name: 'funding_category_graduation',
              field: 'funding_category',
              value: 'Graduation',
            },
            {
              label: 'Living costs',
              name: 'funding_category_living_costs',
              field: 'funding_category',
              value: 'Living costs',
            },
            {
              label: 'Music',
              name: 'funding_category_music',
              field: 'funding_category',
              value: 'Music',
            },
            {
              label: 'Sport',
              name: 'funding_category_sport',
              field: 'funding_category',
              value: 'Sport',
            },
            {
              label: 'Travel',
              name: 'funding_category_travel',
              field: 'funding_category',
              value: 'Travel',
            },
            {
              label: 'Tuition fees',
              name: 'funding_category_tuition_fees',
              field: 'funding_category',
              value: 'Tuition fees',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Funding category")])])]),_c('SelectOptions',{attrs:{"type":"single","options":[
            {
              label: 'All',
              name: 'country_all',
              field: 'country',
              value: '',
              checked: true,
            },
            {
              label: 'China',
              name: 'country_china',
              field: 'country',
              value: 'China',
            },
            {
              label: 'Colombia',
              name: 'country_colombia',
              field: 'country',
              value: 'Colombia',
            },
            {
              label: 'Commonwealth',
              name: 'country_commonwealth',
              field: 'country',
              value: 'Commonwealth',
            },
            {
              label: 'Hong Kong',
              name: 'country_hong_kong',
              field: 'country',
              value: 'Hong Kong',
            },
            {
              label: 'India',
              name: 'country_india',
              field: 'country',
              value: 'India',
            },
            {
              label: 'United States',
              name: 'country_united_states',
              field: 'country',
              value: 'United States',
            },
            {
              label: 'Vietnam',
              name: 'country_vietnam',
              field: 'country',
              value: 'Vietnam',
            },
          ]}},[_c('div',{staticClass:"filter-heading"},[_c('legend',[_vm._v("Location-specific")])])])],1)])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module__header"},[_c('h2',[_vm._v("Search for funding")])])
}]

export { render, staticRenderFns }